import global from './styles/global';
import normalize from './styles/normalize';
import reset from './styles/reset';
import main from './styles/main';
var getResetByTag = function getResetByTag(el) {
  var globalStyles = global(el);
  var normalizeStyles = normalize(el);
  var resetStyles = reset(el);
  var mainStyles = main(el);
  return [globalStyles, normalizeStyles, resetStyles, mainStyles];
};
export default getResetByTag;